import React from "react";
import { PeriodFilter } from "../../common/enums/common.enums";

interface ITabContext {
  tab: string;
  changeTab: (tab: PeriodFilter) => void;
}

export const useTabContext = React.createContext({} as ITabContext);
